import { Parameter } from "@/queries/models";

export const mapParametersToPromptData = (parameters: Parameter[]) => {
  return parameters.reduce(
    (acc, parameter) => {
      acc[parameter.param_id] = parameter.value;
      return acc;
    },
    {} as Record<string, string>,
  );
};
